import { RAuth } from "@/pages/Auth/RAuth";
import { RLayout } from "@/pages/Layout/RLayout";
import { RErrors } from "@/pages/Errors/RErrors";
import { RouteConfig } from "vue-router";
import { RError404 } from "@/pages/Errors/views/Error404/RError404";

export const routes: RouteConfig[] = [RAuth, RLayout, RErrors, RError404];
